import enUS from '@i18n/wpMyAccount/en-US.json'
import zhHK from '@i18n/wpMyAccount/zh-HK.json'
import zhTW from '@i18n/wpMyAccount/zh-TW.json'
import { getWordPressLocale } from '@utils/getWordPressLocale'
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

const resources = {
  zh_TW: {
    translation: { ...zhTW },
  },
  en_US: {
    translation: { ...enUS },
  },
  zh_HK: {
    translation: { ...zhHK },
  },
}

const wordPressLocale = getWordPressLocale()
const language = wordPressLocale
const orderDetailInstance = i18n.createInstance()

orderDetailInstance
  .use(initReactI18next)
  .init({
    resources,
    lng: language,
    interpolation: {
      escapeValue: false,
    },
    saveMissing: true,
  })

export default orderDetailInstance
